export default class Background {
    constructor(parent, router) {
        this.el = parent.el.querySelector('.batd-picture');
        this.defaultPicture = this.el.innerHTML;
        this.template = _.template(parent.el.querySelector('#batd-picture').innerHTML.replaceAll('\\', ''));
    }

    set(el) {
        const desktop = el.dataset.desktopBackground;
        const mobile = el.dataset.mobileBackground;

        if (desktop && mobile) {
            this.el.innerHTML = this.template({ desktop, mobile });
        } else {
            this.el.innerHTML = this.defaultPicture;
        }

        this.animate();
    }

    show() {
        this.el.classList.remove('hide');
    }

    hide() {
        this.el.classList.add('hide');
    }

    animate() {
        const self = this;

        this.el.classList.add('pre-animation');

        setTimeout(() => {
            self.el.classList.remove('pre-animation');
        }, 500);
    }
}
